var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 0C1.232 0 0.605328 0.579469 0.517578 1.32422L8 6L15.4824 1.32422C15.3947 0.579469 14.768 0 14 0H2ZM0.5 2.81396V10.5C0.5 11.3287 1.17125 12 2 12H14C14.8287 12 15.5 11.3287 15.5 10.5V2.81396L8.39697 7.25244C8.15397 7.40394 7.84603 7.40394 7.60303 7.25244L0.5 2.81396Z",
    fill: "#1F4C5C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.17f26ba35a604d6d97f2dfd80ea5425c.svg";
export { ForwardRef as ReactComponent };